import '../utilities/MatchMediaPolyfill'
import 'dom-slider'

const { slideToggle } = window.domSlider

const toggle = ({ button, container, label, labelActive, speed }) => {
  if (!window.matchMedia) return

  const btnEl = document.querySelector(button)

  if (!btnEl) return

  btnEl.addEventListener('click', (e) => {
    slideToggle({
      element: document.querySelector(container),
      slideSpeed: speed || 250,
      easing: 'ease-in-out',
    })

    btnEl.innerText = btnEl.innerText === label ? labelActive : label
  })
}

export default toggle
